import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import ComplianceHubNavigationIcon from 'Icons/NavigationItem/ComplianceHub';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

const LazyComplianceHubSettingsPage = React.lazy(() => import('./Pages'));

const complianceHubConfiguration: FeatureConfiguration = {
    name: 'common:sidebar.featureComplianceHubTitle',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureComplianceHubTitle',
            url: '/compliance-hub-settings',
            Icon: ComplianceHubNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyComplianceHubSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
    // Admin System Hub only when Hub is on and Builder is off — Builder supersedes this menu
    visibilityRule: {
        [LaunchDarklyFlags.ComplianceHub]: true,
        [LaunchDarklyFlags.ComplianceBuilder]: { $ne: true },
    },
};

export default complianceHubConfiguration;
